export const siteGroup = {
    name: '',
    sites: [],
    account: '',
    client: '',
    status: 'ACTIVE',
}
